import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { linkedinCaptureGuard } from './guards/linkedin-capture.guard';

const routes: Routes = [
	{
		path: '',
		canActivate: [linkedinCaptureGuard],
		children: [
			{
				path: '',
				loadChildren: () => import('./homepage/homepage.module').then(m => m.HomepageModule),
				data: { preload: true },
			},
			{
				path: 'products',
				loadChildren: () => import('./products/products.module').then(m => m.ProductsModule),
				data: { preload: true },
			},
			{
				path: 'partners',
				loadChildren: () => import('./partners/partners.module').then(m => m.PartnersModule),
				data: { preload: true },
			},
			{
				path: 'why-power-kiosk',
				loadChildren: () => import('./why-power-kiosk/why-power-kiosk.module').then(m => m.WhyPowerKioskModule),
				data: { preload: true },
			},
			{
				path: 'company',
				loadChildren: () => import('./company/company.module').then(m => m.CompanyModule),
				data: { preload: true },
			},
			{
				path: 'resources',
				loadChildren: () => import('./resources/resources.module').then(m => m.ResourcesModule),
				data: { preload: true },
			},
			// powerkiosk.com/enterprise → contact us with third content variant (enterprise lead gen).
			{
				path: 'enterprise',
				redirectTo: 'company/contact-us/enterprise-lead-gen',
				pathMatch: 'full',
			},
			// powerkiosk.com/ea-form → Orphan landing page with HubSpot form.
			{
				path: 'ea-form',
				redirectTo: 'landing/ea-form',
				pathMatch: 'full',
			},
			{
				path: 'hi-form',
				redirectTo: 'landing/hi-form',
				pathMatch: 'full',
			},
			{
				path: 'se-form',
				redirectTo: 'landing/se-form',
				pathMatch: 'full',
			},
			{
				path: 'solar',
				redirectTo: 'landing/solar',
				pathMatch: 'full',
			},
			{
				path: 'efficiency',
				redirectTo: 'landing/efficiency',
				pathMatch: 'full',
			},
			{
				path: 'allstar-connect',
				redirectTo: 'landing/allstar-connect',
				pathMatch: 'full',
			},
			{
				path: 'schedule-discovery-call',
				redirectTo: 'landing/schedule-discovery-call',
				pathMatch: 'full',
			},
			{
				path: 'privacy-policy',
				loadChildren: () => import('./privacy-policy/privacy-policy.module').then(m => m.PrivacyPolicyModule),
				data: { preload: true },
			},
			{
				path: 'landing',
				loadChildren: () => import('./landing-pages/landing-pages.module').then(m => m.LandingPagesModule),
				data: { preload: true },
			},
			{
				path: '**',
				redirectTo: '',
			},
		],
	},
];

@NgModule({
	imports: [
		RouterModule.forRoot(routes, {
			anchorScrolling: 'enabled',
			scrollPositionRestoration: 'enabled',
		}),
	],
	exports: [RouterModule],
})
export class AppRoutingModule {}
